module.exports = require("@agm/core/services/google-maps-api-wrapper");